import { ChevronLeft } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import Overview from "./overview";
import Account from "./account";
import Manage from "./manage";

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState("overview");
  const navigate = useNavigate();

  const tabs = [
    { id: "overview", label: "Overview", component: Overview },
    { id: "account", label: "Account", component: Account },
    { id: "manage", label: "Manage", component: Manage },
  ];

  return (
    <div className="flex h-screen gap-x-3 mt-4">
      <div className="w-[250px]">
        <button
          onClick={() => navigate({ to: "/overview" })}
          className="mb-4 w-fit flex items-center gap-2 px-2 py-2 rounded-sm text-sm font-semibold text-gray-600 hover:bg-gray-100 bg-transparent"
        >
          <ChevronLeft className="w-5 h-5" />
          Back to app
        </button>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`block w-full px-4 py-2 text-sm text-gray-700 text-left ${
              activeTab === tab.id
                ? "bg-[#F4F4F5] rounded-md"
                : "bg-transparent"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="flex-1 border-l border-gray-200 p-4">
        {activeTab === "overview" && <Overview />}
        {activeTab === "account" && <Account />}
        {activeTab === "manage" && <Manage />}
      </div>
    </div>
  );
}
